import React, { useEffect } from 'react';

import About from '../components/About';
import Tips from '../components/Tips';
import Services from '../components/Services';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import Team from '../components/Team';
import Partners from '../components/Partners';

export default function LandingPage(props) {

    const setMenuSelected = props.setMenuSelected;
    useEffect(() => {
        if (setMenuSelected) {
            window.scrollTo(0, 0);
            setMenuSelected("home");
        }

    }, []);

    return (
        <React.Fragment>
            <Tips />
            <Services />
            <Projects />
            <About />
            {/*<Team />*/}
            <Partners />
            <Contact />
        </React.Fragment>

    );
}
